module.exports = __webpack_public_path__ + "img/Slide39.aa07fa79.png";